import { render, staticRenderFns } from "./infoSec.vue?vue&type=template&id=710d34fe&scoped=true&"
import script from "./infoSec.vue?vue&type=script&lang=js&"
export * from "./infoSec.vue?vue&type=script&lang=js&"
import style0 from "./infoSec.vue?vue&type=style&index=0&id=710d34fe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d34fe",
  null
  
)

export default component.exports